export default "__VITE_ASSET__vVQYziGI__"